const shareButtonHandler = (e) => {
    e.preventDefault();
    const target = e.currentTarget;

    if(target.getAttribute('aria-expanded') === 'true') {
        target.setAttribute('aria-expanded', 'false');
        target.parentNode.classList.remove('open');
    } else {
        target.setAttribute('aria-expanded', 'true');
        target.parentNode.classList.add('open');
    }
}

const copyPageUrlToClipboard = (e) => {
    const target = e.currentTarget,
        buttonText = target.innerHTML,
        urlInput = document.createElement('input'),
        url = window.location.href,
        parent = document.querySelector('.url_keeper');

    // comunicate for client that he coppied url
    target.classList.add('share__copy-button--green');
    target.innerHTML='Copied';
    setTimeout(() => {
        target.classList.remove('share__copy-button--green');
        target.innerHTML=buttonText;
    }, 1000);

    // copy url to clipboard
    urlInput.value = url;
    parent.appendChild(urlInput);
    urlInput.select();
    document.execCommand('copy');
    parent.removeChild(urlInput);
};

[...document.querySelectorAll('.share__active-button--js')].map(el => {
    el.addEventListener('click', shareButtonHandler);
});

[...document.querySelectorAll('.copy-link--js')].map(el => {
    el.addEventListener('click', copyPageUrlToClipboard);
});

